import { gql } from '@apollo/client';

export const CHANGE_AUTO_ROUTE_DRIVER = gql`
    mutation ChangeAutoRouteDriver($driverTaskId: Long!, $driverAccountId: Long!, $driverName: String!) {
        changeAutoRouteDriver(driverTaskId: $driverTaskId, driverAccountId: $driverAccountId, driverName: $driverName)
    }
`;

export interface ChangeAutoRouteDriverVariables {
    driverTaskId: number;
    driverAccountId: number;
    driverName: string;
}

export interface ChangeAutoRouteDriverResponse {
    changeAutoRouteDriver: boolean;
}
